"use client";

// The holiday icon in the header's left group (a pumpkin at Halloween, a
// snowflake at Christmas …): switches högtidsteman off and on, the same
// account setting as Inställningar → Utseende. Only during a holiday, never
// on phones or on the pages where the effects are never shown.

import { usePathname } from "next/navigation";
import { arHogtidUndantag } from "@/lib/hogtider";
import { useHogtid } from "@/lib/hogtid";
import { HogtidIkon } from "./figurer";
import { useRorelseTillaten } from "./useRorelseTillaten";

export default function HogtidKnapp() {
  const vag = usePathname() ?? "/";
  const { pa, setPa, hogtid } = useHogtid();
  const rorelse = useRorelseTillaten();
  if (!hogtid || !rorelse || arHogtidUndantag(vag)) return null;
  const etikett = pa ? `Stäng av högtidstemat (${hogtid.namn})` : `Slå på högtidstemat (${hogtid.namn})`;
  return (
    <button
      type="button"
      onClick={() => setPa(!pa)}
      title={etikett}
      aria-label={etikett}
      aria-pressed={pa}
      className="grid h-9 w-9 place-items-center rounded-md transition-colors hover:bg-[color-mix(in_oklch,var(--color-nav-text)_10%,transparent)]"
    >
      <svg viewBox="0 0 32 32" width="28" height="28" aria-hidden="true" style={{ opacity: pa || hogtid.effekt === "spindlar" ? 1 : 0.45 }}>
        <HogtidIkon effekt={hogtid.effekt} pa={pa} />
      </svg>
    </button>
  );
}
